module.exports = __webpack_public_path__ + "static/img/5-1.7d90100.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/5-1.jpg
// module id = sGiN
// module chunks = 0